// src/utils/themeColorManager.js

let themeMetaTag = null;

/**
 * Atualiza a meta tag theme-color no HTML head.
 * Se a meta tag não existir, ela será criada.
 * @param {string} color - A cor em formato CSS (ex: '#FF50A3', 'rgb(255, 0, 0)').
 */
export function updateThemeColor(color) {
  if (typeof document === 'undefined') {    
    return; // Não executa no SSR (Server-Side Rendering) se você estivesse usando
  }

  if (!themeMetaTag) {
    themeMetaTag = document.querySelector('meta[name="theme-color"]');
    if (!themeMetaTag) {
      themeMetaTag = document.createElement('meta');
      themeMetaTag.setAttribute('name', 'theme-color');
      document.head.appendChild(themeMetaTag);
    }
  }
  themeMetaTag.setAttribute('content', color);
}

/**
 * Remove a meta tag theme-color do HTML head (opcional).
 */
export function removeThemeColor() {
  if (typeof document === 'undefined') {
    return;
  }
  if (themeMetaTag && themeMetaTag.parentNode) {
    themeMetaTag.parentNode.removeChild(themeMetaTag);
    themeMetaTag = null;
  }
}